var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLesson(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.16429 0 0 7.16429 0 16C0 24.8357 7.16429 32 16 32C24.8357 32 32 24.8357 32 16C32 7.16429 24.8357 0 16 0ZM16 29.2857C8.66429 29.2857 2.71429 23.3357 2.71429 16C2.71429 8.66429 8.66429 2.71429 16 2.71429C23.3357 2.71429 29.2857 8.66429 29.2857 16C29.2857 23.3357 23.3357 29.2857 16 29.2857Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.4075 15.5394L12.8325 7.86085C12.7477 7.79867 12.6472 7.76127 12.5424 7.75282C12.4376 7.74436 12.3325 7.76517 12.2388 7.81294C12.1451 7.86071 12.0665 7.93356 12.0118 8.02336C11.9571 8.11316 11.9284 8.2164 11.9289 8.32156V23.6787C11.9289 24.1466 12.4575 24.4108 12.8325 24.1394L23.4075 16.4608C23.4805 16.4082 23.5399 16.339 23.581 16.2589C23.622 16.1788 23.6434 16.0901 23.6434 16.0001C23.6434 15.9101 23.622 15.8214 23.581 15.7413C23.5399 15.6612 23.4805 15.592 23.4075 15.5394ZM14.2075 20.3251V11.6751L20.161 16.0001L14.2075 20.3251Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesson);
export default __webpack_public_path__ + "static/media/lesson.4f6d55fc4f57e438afb3fd74b550e2e1.svg";
export { ForwardRef as ReactComponent };